module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/Payments/images/mastercard-21ed4277de5400b20e699c8ed3716599.svg";